import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const Process = () => {
  const { lang } = useLanguage();
  const isSpanish = lang === 'es';

  const content = isSpanish
    ? {
        heading: 'De la experiencia a los clientes',
        steps: [
          {
            step: '01',
            title: 'Haz que tu valor sea claro',
            desc: 'Tu negocio ya tiene algo que merece la pena comprar. Nos aseguramos de que la gente entienda por qué.'
          },
          {
            step: '02',
            title: 'Gana atención',
            desc: 'Creamos contenido que hace que las personas adecuadas se fijen en ti.'
          },
          {
            step: '03',
            title: 'Genera confianza',
            desc: 'Tu contenido demuestra tu experiencia antes de que empiece la conversación de ventas.'
          },
          {
            step: '04',
            title: 'Haz que comprar sea fácil',
            desc: 'Creamos un camino sencillo desde el interés hasta la consulta, la reserva o la compra.'
          },
          {
            step: '05',
            title: 'Convierte consultas en reuniones',
            desc: 'Cualificamos a los prospectos entrantes y convertimos automáticamente el interés real en conversaciones reservadas.'
          }
        ]
      }
    : {
        heading: 'From expertise to customers.',
        steps: [
          {
            step: '01',
            title: 'Make your value clear',
            desc: 'Your business already has something worth buying. We make sure people understand why.'
          },
          {
            step: '02',
            title: 'Earn attention',
            desc: 'We create content that gets you noticed by the right people.'
          },
          {
            step: '03',
            title: 'Build trust',
            desc: 'Your content demonstrates your expertise before the sales conversation even starts.'
          },
          {
            step: '04',
            title: 'Make buying easy',
            desc: 'We create a simple path from interest to enquiry, booking or purchase.'
          },
          {
            step: '05',
            title: 'Turn enquiries into meetings',
            desc: 'We qualify incoming prospects and automatically turn genuine interest into booked conversations.'
          }
        ]
      };

  return (
    <section className="py-24 px-6 bg-zinc-900">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-5xl font-bold text-white text-center mb-20"
        >
          {content.heading}
          <span className="text-orange-500">.</span>
        </motion.h2>

        <div className="space-y-12">
          {content.steps.map((item, index) => (
            <motion.div
              key={item.step}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex flex-col md:flex-row gap-6 md:items-center p-8 bg-zinc-950 border-l-4 border-orange-500 rounded-r-2xl"
            >
              <div className="flex-shrink-0">
                <span className="text-orange-500 font-black tracking-widest text-sm">
                  {item.step}
                </span>
                <h3 className="text-2xl font-bold text-white">
                  {item.title}
                </h3>
              </div>

              <div className="md:ml-auto md:max-w-md">
                <p className="text-zinc-400 leading-relaxed">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;